export default "public/NoteIcon.svg";